import axios from 'axios'
import { SERVER_URL, LOAD_AMMOUNT } from './constants'

export const loadMorePosts = (startIndex, cb, is89) => {
  const name = is89 ? 'pagination89' : 'pagination'
  const url = `${SERVER_URL}/api/items/${name}/${startIndex}/${LOAD_AMMOUNT}`
  axios
    .get(url)
    .then((res) => {
      cb(res.data)
    })
    .catch((error) => {
      if (window.Raven) {
        window.Raven.captureException(error, { extra: 'load more posts error' })
      }
    })
}



// WEBPACK FOOTER //
// ./src/actions.js